// Category-pill labels for the catalog filter tabs. The cards themselves
// (and the API-record → card-props mapping) now come from @astro/course-card.

/** Emoji per course-category slug for the filter-tab pills. */
const CATEGORY_EMOJI = {
  'career-counseling': '💼',
  'gems-stone-guidance': '💎',
  'kundli-matching': '💍',
  'vastu-shastra': '🏡',
  'vedic-astrology': '🔮',
  palmistry: '🖐',
  numerology: '🔢',
}

/** The API exposes `category` as a display name only — slugify it for
 * the emoji lookup ("Vedic Astrology" → "vedic-astrology"). */
const categorySlug = (name) =>
  String(name ?? '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const categoryPill = (name) => `${CATEGORY_EMOJI[categorySlug(name)] ?? '🔮'} ${name}`
